import React, { lazy, Suspense, useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  getFeaturedSkills,
  getRelatedSkills,
  getSkill,
} from "../../redux/actions/skills";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHourglass, faPlayCircle } from "@fortawesome/free-solid-svg-icons";
import Spinner from "../../components/Spinner";
import Slider from "react-slick";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { IKImage } from "imagekitio-react";
import SearchBar from "../HomePage/Personalize/SearchBar";
import LazySpinner from "../../components/LazySpinner";
import { trackUserShare } from "../../redux/actions/userActivity";
const OurLearnersWorkAt = lazy(() => import("../../components/Carousel"));

const ContentShare = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [skillData, setSkillData] = useState({});
  const [content, setContent] = useState("");
  const user_id = useSelector((store) => store?.profileDetails?.id);
  const dispatch = useDispatch();
  const [relatedSkills, setRelatedSkills] = useState(null);
  const [dropdownResult, setDropdownResult] = useState([]);
  const navigate = useNavigate();
  const { uuid } = useParams();
  const [userData , setUserData] = useState({name : ""});

  const testimonials = [
    "https://assets.learntube.ai/files/Learntube/Group%2010111.png?updatedAt=1705910940053",
    "https://assets.learntube.ai/files/Learntube/Group%2010109.png?updatedAt=1705910940062",
    "https://assets.learntube.ai/files/Learntube/Group%2010113.png?updatedAt=1705910940058",
    "https://assets.learntube.ai/files/Learntube/Group%2010112.png?updatedAt=1705910940027",
    "https://assets.learntube.ai/files/Learntube/Group%2010114.png?updatedAt=1705910939937",
    "https://assets.learntube.ai/files/Learntube/Group%2010104.png?updatedAt=1705910927098",
    "https://assets.learntube.ai/files/Learntube/Group%2010106.png?updatedAt=1705910927101",
    "https://assets.learntube.ai/files/Learntube/Group%2010102.png?updatedAt=1705910927094",
    "https://assets.learntube.ai/files/Learntube/Group%2010105.png?updatedAt=1705910927011",
    "https://assets.learntube.ai/files/Learntube/Group%2010107.png?updatedAt=1705910927009",
    "https://assets.learntube.ai/files/Learntube/Group%2010122.png?updatedAt=1706858076798",
    "https://assets.learntube.ai/files/Learntube/Group%2010103.png?updatedAt=1705910926934",
    "https://assets.learntube.ai/files/Learntube/Group%2010099.png?updatedAt=1705910926911",
    "https://assets.learntube.ai/files/Learntube/Group%2010098.png?updatedAt=1705910926833",
  ];

  const testimonialSettings = {
    dots: false,
    slidesToShow: 5,
    rows: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "linear",
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.2,
          infinite: true,
          dots: false,
          arrows: false,
          swipeToSlide: true,
        },
      },
    ],
  };

  const settings = {
    dots: false,
    slidesToShow: Math.min(4, relatedSkills?.length + 1),
    rows: 1,
    speed: 300,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "linear",
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.5,
          infinite: false,
          dots: false,
          arrows: false,
          swipeToSlide: true,
        },
      },
    ],
  };

  useEffect(() => {
    dispatch(
      trackUserShare(
        uuid,
        (successObj) => {
          let newContent = successObj?.data?.raw_url
            ?.split("?")?.[0]
            ?.split("/");
          let ans = "";
          for (let i = 3; i < newContent?.length - 1; i++) {
            ans += "/" + newContent[i];
          }
          if (!user_id) ans += "/new_user";

          setContent(ans);
          setUserData(successObj?.data?.sharing_user);

          dispatch(
            getSkill(
              0,
              successObj?.data?.raw_url?.split("/")?.[4],
              (successObj) => {
                setSkillData(successObj);
                dispatch(
                  getRelatedSkills(
                    successObj?.id,
                    (res) => {
                      if (res?.data?.length == 0) {
                        setRelatedSkills([]);
                        dispatch(
                          getFeaturedSkills((successObj1) => {
                            setRelatedSkills(successObj1?.newSkills);
                          })
                        );
                      } else {
                        setRelatedSkills(res?.data);
                      }
                    },
                    (err) => {}
                  )
                );
              },
              (errorObj) => {}
            )
          );
        },
        (errorObj) => {}
      )
    );
  }, []);

  const images = [
    "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/hyM-qWXA3Wcnf8nDo6VYd2zzNEk/nOrgNA../Ellipse+1045.png",
    "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/TCvWgSqs5vV6brI4n5w-GfvCgYo/-rEsdQ../Ellipse+1049.png",
    "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/tw06GFF_zwoDiPZzdlV319Bee1U/pwOWsg../Ellipse+1046.png",
    "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/t8FxQIi-9omN-79egpQJpHX7JzM/qBDROQ../Ellipse+1047.png",
    "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/PpwT3vTr_guNCPc3_lJs8MjZ2x8/jvz6gQ../Ellipse+1048.png",
  ];
  return (
    <div className="bg-white">
      <div className="mx-auto flex w-full flex-col items-center justify-center md:w-[80%]">
        <div className="my-4 flex w-full flex-col items-center justify-center py-4 px-4 md:my-10 md:px-0 md:py-4">
          <div className="skill-container flex w-full flex-col items-center justify-center rounded-xl border-2 md:flex-row">
            <img
              src={skillData?.skill_thumbnail}
              className="rounded-t-xl md:mr-4 md:h-full md:w-[40%] md:rounded-t-none md:rounded-l-xl"
            ></img>
            <div className="flex w-full flex-col items-start justify-center p-4 ">
              <div className="text-[14px] text-gray-400 md:text-[20px]">
                {skillData?.["course-name"]}
              </div>
              <div className="text-[20px] md:text-[28px]">
                {skillData?.["skill-name"]}
              </div>
              <div className="mt-4 flex w-full items-center justify-start gap-4">
                <div className="flex items-center justify-center gap-2 border-r-2 border-r-gray-400 pr-3">
                  <div className="h-[24px] w-[24px]">
                    <FontAwesomeIcon
                      icon={faPlayCircle}
                      className="h-full w-full object-fill"
                    />
                  </div>
                  <div className="text-[14px]">
                    {skillData?.lesson_count} Lessons
                  </div>
                </div>
                <div className="flex items-center justify-center gap-2">
                  <div className="h-[24px] w-[24px] ">
                    <FontAwesomeIcon
                      icon={faHourglass}
                      className="h-full w-full object-fill"
                    />
                  </div>
                  <div className="text-[14px]">
                    {(skillData?.["skill_duration"] / (60 * 60))?.toFixed(1)} Hrs
                  </div>
                </div>
              </div>
              <div className="mt-5 flex w-full flex-col items-center justify-center md:mt-6 md:w-[50%] ">
                <button
                  className=" w-full  rounded-lg bg-[#1BA671] p-2 text-[16px] font-medium text-white"
                  onClick={(e) => {
                    if (!user_id) {
                      navigate(content?.split("?")?.[0]);
                    } else navigate(content);
                  }}
                >
                  Start Learning
                </button>
                <div className="mt-1 flex w-full items-center justify-center gap-4 text-center text-[16px] md:mt-2">
                  Join{" "}
                  <div className="flex">
                    {images.map((src, index) => (
                      <div
                        key={index}
                        className="-ml-2 h-[20px] w-[20px] rounded-full"
                      >
                        <img
                          className="h-full w-full rounded-full object-cover outline outline-1 outline-white"
                          src={src}
                          alt={`Social proof ${index + 1}`}
                        />
                      </div>
                    ))}
                  </div>{" "}
                  <span className="-ml-2">{userData?.name} & 38 Others</span>
                </div>
              </div>
            </div>
          </div>

          {relatedSkills == null ? (
            <Spinner></Spinner>
          ) : (
            <div className="mt-4 w-full md:mt-14">
              <div className="arrow-scroll mb-1 text-[20px] font-semibold md:text-[24px]">
                Explore Related Courses
              </div>
              <Slider {...settings}>
                {relatedSkills?.map((post) => (
                  <div className="h-[280px] p-2">
                    <div className=" h-full w-full rounded-xl border-2 border-gray-200 leading-tight">
                      <div className="h-[140px] w-full">
                        <img
                          src={post["skill_thumbnail"]}
                          alt=""
                          effect="blur"
                          className="h-full w-full rounded-t-xl object-cover"
                        ></img>
                      </div>

                      <div className="flex w-full flex-col items-start justify-center p-2">
                        <div className="text-[14px]  text-gray-400 line-clamp-1">
                          {post?.["course-name"]}
                        </div>
                        <div className="text-[20px] line-clamp-1">
                          {post?.["skill-name"]}
                        </div>
                        <button
                          className="mt-4 w-full rounded-lg bg-[#1BA671] p-2 text-[16px] font-medium text-white md:mt-6"
                          onClick={(e) =>
                            navigate(
                              "/" +
                                skillData?.course_slug +
                                "/" +
                                skillData?.skill_slug
                            )
                          }
                        >
                          Explore Course
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
                <div className="flex h-[280px] items-center justify-center p-2 text-center leading-tight">
                  <div className="leading-tigh flex h-full w-full flex-col items-center justify-center rounded-xl border-2 border-gray-200 bg-[#27C396] px-4 py-6">
                    <img
                      urlEndpoint="https://assets.learntube.ai/files/"
                      src="https://assets.learntube.ai/files/Share%20/Group%2020923.svg?updatedAt=1722502126842"
                      className="mt-2"
                      transformation={[
                        {
                          height: "50",
                          width: "50",
                        },
                      ]}
                    />
                    <div className="mt-4 text-[20px] font-semibold text-white">
                      Looking for something else?
                    </div>
                    <div
                      className="mt-4 w-full cursor-pointer rounded-xl bg-white p-4 text-[14px] font-medium text-[#1BA671]"
                      onClick={(e) => navigate("/" + skillData?.course_slug)}
                    >
                      Explore by Category
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          )}

          <div className="default-box-shadow mt-6 w-full rounded-xl bg-[#D4F4FF] p-4  leading-tight md:mt-14 md:p-8">
            <div className="flex flex-col items-center justify-between md:flex-row ">
              <div className=" flex flex-row items-center justify-center">
                <img
                  urlEndpoint="https://assets.learntube.ai/files/"
                  src="https://assets.learntube.ai/files/Learntube/Group%2010115.svg?updatedAt=1705911336153"
                  className="mr-4 h-[76px] w-[88px] md:h-[100px] md:w-[115px]"
                  transformation={[
                    {
                      height: "50",
                      width: "50",
                    },
                  ]}
                />
                <div className="text-[18px] md:text-[24px] ">
                  <span className="font-semibold text-[#1F90CF]">
                    Do You Want To Learn Something Else?
                  </span>
                </div>
              </div>
              <div className="mt-4 w-full  md:mt-0 md:w-[50%]">
                <div className="mb-2 text-[14px] font-semibold text-[#12546B]">
                  Search Or Add Any Course
                </div>
                <SearchBar
                  token={""}
                  type={2}
                  count={false}
                  dropdownResult={dropdownResult}
                  setDropdownResult={setDropdownResult}
                  utmSource={'sharePage'}
                />
              </div>
            </div>
            <div className="mt-4 text-[13px] md:text-[16px]">
              <span className="font-semibold text-[#1F90CF]">Every minute</span> a
              new course is created on LearnTube
            </div>
            <div className="mt-2 w-full">
              <Slider {...testimonialSettings}>
                {testimonials?.length > 0 &&
                  testimonials?.map((item, index) => (
                    <img
                      src={item}
                      alt="testimonials"
                      className="p-2"
                      width="auto"
                      height={"auto"}
                    ></img>
                  ))}
              </Slider>
            </div>
          </div>
          <div className="mt-6 flex w-full flex-col md:mt-14">
            <h2 className=" w-full text-[20px] font-semibold text-black md:text-[24px]">
              Our Learners Work At
            </h2>
            <div className="mx-auto flex w-full flex-col items-center justify-center">
              <Suspense fallback={LazySpinner}>
                {" "}
                <OurLearnersWorkAt />
              </Suspense>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentShare;
